var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardBridgeWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1077_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.158 3.13033L134 7.55979V13C134 55.5241 99.3917 92 58.5 92C16.8025 92 -17 58.1975 -17 16.5V7.1301L-24.9221 2.12666C-31.247 -1.86802 -34.287 -5.62552 -35.7487 -8.55052C-37.15 -11.3545 -37.6344 -14.4404 -37.0482 -18.2275C-35.7481 -26.6257 -29.1914 -37.8098 -16.9218 -49.8822C-5.0427 -61.5704 10.4218 -72.3321 25.8605 -80.1178C41.6708 -88.0907 55.5779 -92 64.5 -92C84.1259 -92 111.613 -78.8311 129.479 -58.3786C138.16 -48.4407 143.591 -37.8523 145.167 -27.7097C146.675 -18.0045 144.855 -7.66415 137.158 3.13033Z",
    stroke: "white",
    strokeWidth: 34
  }), /*#__PURE__*/React.createElement("rect", {
    y: 80,
    width: 117,
    height: 37,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1077_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 117,
    fill: "white",
    transform: "translate(117 117) rotate(-180)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBridgeWhite);
export default __webpack_public_path__ + "static/media/card-bridge-white.c04f46934445861db69904f929d09adb.svg";
export { ForwardRef as ReactComponent };